var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import React from 'react';
import { IconButton, IconButtonRole, IconButtonSize, IconButtonStyles } from '../../../../atoms/icon-button';
import { Text, TextVariants } from '../../../../atoms/text';
import { Tooltip } from '../../../../atoms/tooltip';
import { TooltipDesignStyles } from '../../../../atoms/tooltip/types';
import { Gauge } from '../../../../molecules/gauge';
import { Container, ContainerDisplays, ContainerFlexAlignItems, ContainerFlexGaps } from '../../../../templates/container';
var IG = function (_a) {
    var label = _a.label, value = _a.value, scale = _a.scale, info = _a.info, ariaLabel = _a["aria-label"];
    var iconConfig = {
        icon: 'pmi-icon-info',
        size: IconButtonSize.Medium,
        style: IconButtonStyles.Empty,
        role: IconButtonRole.Button,
        'aria-label': ariaLabel || "gauge-".concat(label, "-").concat(value)
    };
    var wrapperConfiguration = {
        display: ContainerDisplays.Flex,
        flexGap: ContainerFlexGaps.Size_2,
        flexAlignItems: ContainerFlexAlignItems.Center
    };
    var gaugeConfig = {
        value: value,
        scale: scale
    };
    var labelConfig = {
        content: "<b>".concat(label, "</b>"),
        isHtml: true,
        variant: TextVariants.Body2
    };
    var tooltipConfig = {
        title: React.createElement(Text, { isHtml: true, content: info, variant: TextVariants.Body1 }),
        designStyle: TooltipDesignStyles.Primary
    };
    return (React.createElement(Container, __assign({}, wrapperConfiguration),
        Boolean(value) && Boolean(scale) && React.createElement(Gauge, __assign({}, gaugeConfig)),
        label && React.createElement(Text, __assign({}, labelConfig)),
        info && (React.createElement(Tooltip, __assign({}, tooltipConfig),
            React.createElement(IconButton, __assign({}, iconConfig))))));
};
export { IG as IntensityGauge };
